import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PatientAttachment } from '../../../core/models/patient-attachment.model';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'app-consult-note-nav',
    templateUrl: './consult-note-nav.component.html',
    styleUrls: ['./consult-note-nav.component.scss'],
    imports: [MatIcon]
})
export class ConsultNoteNavComponent {
  @Input() currentSection: string;
  @Input() patientAttachment: PatientAttachment;
  @Input() canAdmin = false;
  @Output() sectionClick = new EventEmitter<string>();

  constructor() {}


  onNavClick($event, sectionId) {
    $event.preventDefault();
    this.sectionClick.emit(sectionId);
  }
}
